import {
  QuotationConstructionItemStaged,
  QuotationMaterialItemStaged,
  QuotationSubjectStaged,
} from '@euler/model/task-detail';
import { createContext, useContext } from 'react';
import { BehaviorSubject } from 'rxjs';

export type MaterialBeingEdited = {
  key: string;
  subject: QuotationSubjectStaged;
  item: QuotationConstructionItemStaged;
} & (
  | {
      type: 'new';
    }
  | {
      type: 'edit';
      material: QuotationMaterialItemStaged;
      index: number;
    }
);

export type ConstructionItemBeingEdited = {
  key: string;
  subject: QuotationSubjectStaged;
} & (
  | {
      type: 'new';
    }
  | {
      type: 'edit';
      item: QuotationConstructionItemStaged;
      index: number;
    }
);

export type QuotationFormContextProps = {
  editable: boolean;
  subjectWhoseIssuesBeingEdited$: BehaviorSubject<
    QuotationSubjectStaged | undefined
  >;
  materialBeingEdited$: BehaviorSubject<MaterialBeingEdited | undefined>;
  constructionItemBeingEdited$: BehaviorSubject<
    ConstructionItemBeingEdited | undefined
  >;
};

export const QuotationFormContext = createContext<QuotationFormContextProps>(
  null as any,
);

export const useQuotationFormContext = () => {
  return useContext(QuotationFormContext);
};
